export const locale = {
  lang: 'en-CA',
  data: {
    CONVERT_SUBMISSION: {
      TITLE: 'Convert the quote request',
      DOCUMENT_TYPE: 'Create',
      TYPE_PROPOSAL: 'A proposal',
      TYPE_ORDER: 'An order',
      GUEST_COUNT: 'Guest count',
      REQUESTED_TIME: 'Requested time',
      REQUESTED_GUESTS: 'Guests',
      RESPONSIBLE_EMPLOYEE: 'Advisor',
      SELECT_RESPONSIBLE_EMPLOYEE: 'Select an advisor',
      RESPONSIBLE_EMPLOYEE_HINT: 'Leave empty to assign the request to yourself.',
      CLIENT: 'Client',
      CLIENT_MATCH: 'Use the existing client found by email: ',
      CLIENT_CREATE: 'Create a new client: ',
      CLIENT_CHOOSE: 'Choose another client',
      SEARCH_CLIENT: 'Search a client',
      NOTE_HINT:
        'Every form field will be copied into the general note of the created document; the request will be archived and linked to the client and the event.',
      CONVERT: 'Convert',
    },
  },
};
